var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.936,
    height: 54.901,
    viewBox: "0 0 11.625 14.526",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.822 5.24H4.05V3.082a1.762 1.762 0 013.522 0v.565h1.379v-.565a3.14 3.14 0 00-6.28 0V5.24h-.868A1.805 1.805 0 000 7.043v5.68a1.805 1.805 0 001.803 1.803h8.02a1.805 1.805 0 001.802-1.803v-5.68A1.805 1.805 0 009.822 5.24zM1.378 7.043c0-.235.19-.425.425-.425h8.019c.234 0 .424.19.425.425v5.68c0 .235-.19.425-.425.425h-8.02a.425.425 0 01-.424-.425z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.812 11.908A1.162 1.162 0 006.5 9.81V8.657a.69.69 0 00-1.378 0v1.154a1.162 1.162 0 00.69 2.097z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton2);
export default __webpack_public_path__ + "static/media/button2.29e7c6db.svg";
export { ForwardRef as ReactComponent };